define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var PortletView = require('modules/portlet/portlet.view');
    var Form = require('class/form.class');
    var user = require('user');
    var core = require('core');
    var dispatcher = require('bundle').dispatcher;
    var launcher = require('modules/launcher/launcher');

    module.exports = PortletView.extend({

        templateName: 'updatedetails',

        accessRules: {
            allow: ['user']
        },

        events: {
            'input input': 'checkForChanges',
            'change select': 'checkForChanges',
            'submit form': 'updateUserDetails'
        },

        userDetails: {},

        render: function() {
            this.$el.html(this.tmpl(this.templateName));

            // It's a hack. One day we should move all this logic to model
            this.getUserDetails();

            return this;
        },

        getUserDetails: function() {
            return user.fetchUserDetails()
                .then(function(userDetails) {
                    this.userDetails = userDetails?.data
                        ? _.clone(userDetails.data)
                        : {};

                    // remove '2' prefix from IMS taxResidenceRegion value, code value should be 2 characters long
                    if (this.userDetails.taxResidenceRegion && this.userDetails.taxResidenceRegion.length === 3) {
                        this.userDetails.taxResidenceRegion = this.userDetails.taxResidenceRegion.substr(1, 2);
                    }

                    this.renderUserDetails(this.userDetails);
                }.bind(this))
                .catch(this.renderNetworkError.bind(this));
        },

        renderUserDetails: function(data) {
            var userDetails = { ...data };

            userDetails.name = _.compact([userDetails.title, userDetails.firstName, userDetails.lastName]).join(' ');

            this.$el.html(this.tmpl(this.templateName, userDetails));

            this.form = new Form(this.$('#update-details'), {
                validationConfig: this.options.config.validation
            });

            this.submit = this.$('.btn[type=submit]')[0];
        },

        // You can define this method in your licensee file for processing form data
        getData: function(changedData, allData) {
            if (changedData.countrycode || changedData.countryCode) {
                changedData = _.extend(changedData, {
                    countrycode: changedData.countrycode || changedData.countryCode
                });
            }

            if (!allData.phone && changedData.cellphone) {
                changedData = _.extend(changedData, {
                    phone: changedData.cellphone
                });
            }

            return _.chain(changedData)
                .omit('countryCode', 'name', 'email', 'address4')
                .value();
        },

        checkForChanges: function() {
            if (user.isFastRegistered()) {
                return this.submit.disabled = false;
            }

            this.submit.disabled = !this.form.isDataChanged();
        },

        updateUserDetails: function(e) {
            e.preventDefault();

            this.hideKeyboard();
            this.form.validate(null, null, null, true)
                .done(this.successValidation.bind(this));
        },

        successValidation: function(data) {
            this.changedUserDetails = this.regulationFieldsOnSaveFilter(this.getData(this.form.getChangedData(), data));

            this.userDetails = _.extend({}, this.userDetails, this.changedUserDetails);

            this.submit.disabled = true;
            this.form.showLoading();
            user.save(null, { userDetails: this.changedUserDetails })
                .always(this.form.hideLoading.bind(this.form))
                .done(this.successUpdate.bind(this))
                .fail(this.errorUpdate.bind(this));
        },

        /**
         * Needed for request pin code within Two Factor Auth popup
         */
        resendTwoFactorAuthPin: function() {
            return user.save(null, { userDetails: this.changedUserDetails });
        },

        onTwoFactorAuthSuccess: function() {
            this.submit.disabled = true;
            this.form.showLoading();

            return user.save(null, { userDetails: this.changedUserDetails })
                .always(this.form.hideLoading.bind(this.form))
                .done(this.successUpdate.bind(this))
                .fail(this.errorUpdate.bind(this));
        },

        showTwoFactorAuthPopup: function() {
            dispatcher.dispatch('app:message', {
                ID: 'twoFactorAuthentication',
                data: {
                    onCancel: () => {
                        dispatcher.dispatch('2fa-popup-closed', 'change-details');
                    },
                    onSuccess: this.onTwoFactorAuthSuccess.bind(this),
                    resendHandler: this.resendTwoFactorAuthPin.bind(this)
                }
            });
        },

        regulationFieldsOnSaveFilter: function(data) {
            return data;
        },

        successUpdate: function() {
            this.changedUserDetails = {};
            this.form.updateFormData();
            this.getUserDetails();
            this.showInfo({
                content: this.translate('playtech.mobile.update-my-details.message')
            });
            this.afterContinueRegisterAction();
        },

        errorUpdate: function(response) {
            if (response?.data?.errorCode === 303) {
                this.submit.disabled = false;
                this.showTwoFactorAuthPopup();

                return;
            }

            this.submit.disabled = false;
            this.form.showErrorMessages({
                content: response.data.errorMessage
            });
        },

        afterContinueRegisterAction: function() {
            var data = user.get('afterContinueRegisterAction');

            if (!data) {
                return true;
            }

            user.unset('afterContinueRegisterAction');

            if (data.action === 'launchGame') {
                return launcher.launchGame(data.options.code, data.options.mode, data.options.queryString);
            }

            return core.navigate(data.url || '/');
        }
    });
});
